const initExperienceScrollNavbar = () => {
  //navbar appears when scrolling
  const navbarExperienceSections = document.getElementById('experience-sections');
  const mainNavbar = document.querySelector('.main-navbar');
  if(navbarExperienceSections){
    window.addEventListener('scroll', function() {
      if (window.scrollY > 0) {
        navbarExperienceSections.classList.remove('md:hidden');
        mainNavbar?.classList.add('md:hidden');
      }
      else {
        navbarExperienceSections.classList.add('md:hidden');
        mainNavbar?.classList.remove('md:hidden');
      }
    });
  }
}

export { initExperienceScrollNavbar }
